import { MessageSquare } from "lucide-react";
import { DCard } from "./dryvn";
import { smsThread, DRYVN_NUMBER } from "@/data/mock";

export function SmsThread() {
  return (
    <DCard className="p-5">
      <div className="mb-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <MessageSquare className="h-4 w-4" style={{ color: "var(--dryvn-primary)" }} />
          <span
            className="font-mono text-[10px] uppercase tracking-[0.18em]"
            style={{ color: "var(--dryvn-grey)" }}
          >
            SMS · Dryvn
          </span>
        </div>
        <a
          href={`sms:${DRYVN_NUMBER}`}
          className="rounded-full px-3.5 py-1.5 text-xs font-medium text-white transition-transform hover:scale-[1.02]"
          style={{ backgroundColor: "var(--dryvn-primary)" }}
        >
          Text Dryvn
        </a>
      </div>
      <ul className="space-y-2 font-mono text-[13px]">
        {smsThread.map((m, i) => (
          <li
            key={i}
            className="rounded-xl px-3 py-2"
            style={{
              backgroundColor:
                m.from === "me"
                  ? "var(--dryvn-page-tint)"
                  : "color-mix(in oklab, var(--dryvn-life) 24%, transparent)",
              color: "var(--dryvn-ink)",
            }}
          >
            <span
              className="mr-2 text-[10px] uppercase tracking-wider"
              style={{ color: "var(--dryvn-grey)" }}
            >
              {m.from === "me" ? "you" : "dryvn"}
            </span>
            {m.text}
          </li>
        ))}
      </ul>
    </DCard>
  );
}
